

import { Box, useMediaQuery } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useTheme } from "@mui/material/styles";
import ArrowDownIcon from '../svgComponents/ArrowDownIcon.jsx'

export const Selector = ({
  isColumnDirection,
  active,
  options,
  handleChangeRole,
  width,
  styles,
  disabled,
  isShowIcons,
}) => {
  const theme = useTheme();

  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  const sm = useMediaQuery("(max-width: 600px)");

  const handleChange = value => {
    setIsOpen(false);

    handleChangeRole(value);
  };

  const handleClickOutside = event => {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Box
      sx={{
        position: "relative",
        height: { xs: "30px", sm: "37px" },
        minHeight: { xs: "30px", sm: "40px" },
        minWidth: isColumnDirection ? "100%" : width,
        zIndex: 100,
        boxSizing: "border-box",
        width: "fit-content",
      }}
      ref={ref}
      onClick={event => event.stopPropagation()}
    >
      <Box
        className="dark:bg-blue-darkMode-10 dark:!text-white"
        component={"div"}
        sx={{
          boxSizing: "border-box",
          border: "1px solid #5763F3",
          position: "absolute",
          top: 0,
          left: 0,
          minWidth: isColumnDirection ? "100%" : width,
          minHeight: { xs: "30px", sm: "40px" },
          borderRadius: "8px",
          fontSize: "14px",
          fontWeight: 500,
          textTransform: "none",
          boxShadow: "0px 0px 6px #00000029",
          cursor: "pointer",
          backgroundColor:
					theme.palette.mode === "light" ? theme.palette.background.default : "#151447",
          ...styles,
        }}
      >
        <Box
          className="dark:!text-white"
          component={"button"}
          sx={{
            boxSizing: "border-box",
            minWidth: isColumnDirection ? "100%" : width,
            position: "relative",
            borderRadius: "8px",

            textTransform: "uppercase",
            pl: { xs: "8px", sm: "16px" },
            height: { xs: "30px", sm: "37px" },
            fontSize: { xs: "12px", sm: "14px" },
            pr: "25px",
            cursor: "pointer",
            minHeight: { xs: "30px", sm: "40px" },
            maxHeight: { xs: "30px", sm: "auto" },
            display: "flex",
            alignItems: "center",
            border: "none",
            backgroundColor: "transparent",
            color: theme.palette.text.primary,
            font: "inherit",
            outline: "none",
            gap: { xs: "4px", sm: "10px" },
            ":disabled": {
              opacity: 0.5,
              cursor: "not-allowed",
            },
          }}
          onClick={() => setIsOpen(state => !state)}
          disabled={disabled}
        >
          {isOpen && (
            <span
              className={
                "absolute bg-[#F1F2F5] dark:bg-blue-darkMode-50 left-1/2 -translate-x-1/2 bottom-[-1px] w-full h-[1px]"
              }
            />
          )}
          {isShowIcons && (
            <img
              className="w-[12px] h-[12px] custom750:w-[16px] custom750:h-[16px]"
              src={active?.logo || active?.iconUrl}
              alt="logo"
            />
          )}
          {active?.title || active?.symbol}
          <div className="right-[5px] text-black dark:text-white pointer-events-none absolute top-1/2 -translate-y-1/2">
            <ArrowDownIcon
              className={`w-[10px] h-[10px] ${!sm && "h-[15px] w-[15px] mr-2"}`}
              style={{ transform: isOpen ? "rotate(180deg)" : "" }}
            />
          </div>
        </Box>
        <>
          {options.map((el, i) => (
            <Box
              onClick={() => handleChange(el.title || el.symbol)}
              key={i}
              sx={{
                boxSizing: "border-box",
                minWidth: isColumnDirection ? "100%" : width,
                borderRadius: "8px",
                textTransform: "uppercase",
                pl: { xs: "8px", sm: "16px" },
                height: { xs: "30px", sm: "37px" },
                fontSize: { xs: "12px", sm: "14px" },
                pr: "25px",
                cursor: "pointer",
                display: isOpen ? "flex" : "none",
                alignItems: "center",
                position: "relative",
                gap: { xs: "4px", sm: "10px" },
              }}
            >
              {isShowIcons && (
                <img
                  width={16}
                  height={16}
                  src={el.logo || el.iconUrl}
                  alt={el.title || el.symbol}
                />
              )}
              {el.title || el.symbol}
            </Box>
          ))}
        </>
      </Box>
    </Box>
  );
};
